module.exports = __webpack_public_path__ + "img/contactus.fb6dd38a.jpg";